import { Box, Group } from '@mantine/core';
import styles from './SeriesCheckboxLabel.module.css';

export const SeriesCheckboxLabel = ({ color, name }: { color: string; name: string }) => (
    <Group className={styles.group}>
        <Box className={styles.colorDot} style={{ backgroundColor: color }} />
        <span>{name}</span>
    </Group>
);
